import React, { useEffect, useState } from 'react';
import { loadHistory } from '../../utils/commandService';
import './Admin.styles.css';

const Admin = () => {
  const [history, setHistory] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setHistory(loadHistory());
  }, []);

  // Mock stats - replace with real data
  const stats = {
    totalDevices: history.length || 128,
    activeOnline: Math.floor((history.length || 128) * 0.89),
    offline: Math.floor((history.length || 128) * 0.11),
    last24hEvents: 1402
  };

  const filteredHistory = history.filter(h =>
    h.deviceId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    h.command?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      {/* Stats Cards */}
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <p className="admin-stat-label">Total Devices</p>
          <h3 className="admin-stat-value">{stats.totalDevices}</h3>
        </div>
        <div className="admin-stat-card">
          <p className="admin-stat-label">Active Online</p>
          <h3 className="admin-stat-value success">{stats.activeOnline}</h3>
        </div>
        <div className="admin-stat-card">
          <p className="admin-stat-label">Offline</p>
          <h3 className="admin-stat-value error">{stats.offline}</h3>
        </div>
        <div className="admin-stat-card">
          <p className="admin-stat-label">Last 24h Events</p>
          <h3 className="admin-stat-value">{stats.last24hEvents}</h3>
        </div>
      </div>

      <div className="admin-table-container">
        {/* Table Header */}
        <div className="admin-table-header">
          <div className="admin-table-search-wrapper">
            <div className="admin-search-input-wrapper">
              <span className="material-icons-outlined">search</span>
              <input
                type="text"
                className="admin-search-input"
                placeholder="Search by Device ID or Command..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <button className="admin-filter-btn">
              <span className="material-icons-outlined">filter_list</span>
              Filter
            </button>
          </div>
          <div className="admin-table-sort">
            <span className="admin-table-sort-label">Sort by:</span>
            <select>
              <option>Last Update (Newest)</option>
              <option>Device ID (A-Z)</option>
              <option>Status</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Device ID</th>
                <th>Command</th>
                <th>Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredHistory.length > 0 ? (
                filteredHistory.map(h => (
                  <tr key={h.id}>
                    <td>
                      <div className="admin-table-device-info">
                        <span className="admin-table-device-name">{h.deviceId || 'Unknown Device'}</span>
                        <span className="admin-table-device-id">ID: #{h.id}</span>
                      </div>
                    </td>
                    <td>
                      <span className="admin-table-mono">{h.command}</span>
                    </td>
                    <td>
                      <div className="admin-table-time">
                        <span className="admin-table-time-primary">
                          {new Date(h.timestamp).toLocaleTimeString()}
                        </span>
                        <span className="admin-table-time-secondary">
                          {new Date(h.timestamp).toLocaleDateString()}
                        </span>
                      </div>
                    </td>
                    <td>
                      <span className={`admin-table-status-badge ${h.status === 'success' ? 'online' : h.status === 'pending' ? 'offline' : 'error'}`}>
                        <span className="status-dot"></span>
                        {h.status || 'Unknown'}
                      </span>
                    </td>
                    <td>
                      <div className="admin-table-actions">
                        <button className="admin-table-action-btn" title="View Details">
                          <span className="material-icons-outlined">visibility</span>
                        </button>
                        <button className="admin-table-action-btn" title="More Options">
                          <span className="material-icons-outlined">more_vert</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: 'var(--text-tertiary)' }}>
                    {searchQuery ? 'No results found' : 'No command history available'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredHistory.length > 0 && (
          <div className="admin-table-footer">
            <span className="admin-table-footer-info">
              Showing {Math.min(1, filteredHistory.length)} to {Math.min(5, filteredHistory.length)} of {filteredHistory.length} entries
            </span>
            <div className="admin-pagination">
              <button className="admin-pagination-btn" disabled={currentPage === 1}>
                <span className="material-icons-outlined">chevron_left</span>
              </button>
              <button className="admin-pagination-number active">1</button>
              <button className="admin-pagination-number">2</button>
              <button className="admin-pagination-number">3</button>
              <button className="admin-pagination-btn">
                <span className="material-icons-outlined">chevron_right</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Admin;



